import { render, staticRenderFns } from "./LocationForm.vue?vue&type=template&id=c4a12b58&scoped=true&"
import script from "./LocationForm.vue?vue&type=script&lang=js&"
export * from "./LocationForm.vue?vue&type=script&lang=js&"
import style0 from "./LocationForm.vue?vue&type=style&index=0&id=c4a12b58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a12b58",
  null
  
)

export default component.exports